// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"f01b9d8c","157":"de42e3fb","179":"52342061","196":"5334084e","314":"f5fee58d","332":"99983b49","381":"275e27ad","453":"cad25a87","834":"d3669558","858":"d4dfaaad"}[chunkId] + ".chunk.js";
};